export default __webpack_public_path__ + "static/media/card.21a669fa.svg";